<template>
    <kt-panel>
        <kt-panel-body v-if="gateways.length > 0">
            <form @submit.prevent="submit_open_banking_settings" id="open_banking_settings_form">
                <kt-form-section>
                    <p class="pb-3">
                        {{ $t('notification.label.setTerminalForPay') }}
                    </p>
                    <kt-row >
                        <kt-form-group class="col-12 col-sm-4 col-md-3">
                            <kt-form-label for="recharge_gateway_id">
                                {{ $t('label.gateway') }}
                            </kt-form-label>
                            <select
                                size="5"
                                    name="recharge_gateway_id"
                                    id="recharge_gateway_id"
                                    v-model="form_data.recharge_gateway_id"
                                    class="form-control kt-selectpicker"
                            >
                                <option>{{ $t('selectpicker.nothing') }}</option>
                                <option
                                        v-bind:key="index"
                                        v-for="(gateway, index) in gateways"
                                        v-bind:value="gateway.id"
                                        :selected="gateway.id === form_data.recharge_gateway_id"
                                >
                                    {{ gateway.farsi_name }}
                                </option>
                            </select>
                        </kt-form-group>
                        <kt-form-action class="mt-4">
                            <kt-button
                                    class="m-2"
                                    size="md"
                                    variant="success"
                                    type="submit"
                                    id="submit_btn_open_banking_settings"
                            >
                                {{ $t('btn.update') }}
                            </kt-button>
                        </kt-form-action>
                    </kt-row>
                </kt-form-section>
            </form>
        </kt-panel-body>
    </kt-panel>
</template>
<script>
import {mapGetters} from "vuex";
import $ from "jquery";
import {i18n} from "@/plugins/i18n";

export default {
    name: 'updateWalletSettings',
    props: {
        submit_open_banking_settings: {
            default: () => {
            },
            type: Function
        },
        form_data: {
            default() {
                return {}
            },
            type: Object
        }
    },
    computed: {
        ...mapGetters('collective', [
            'gateways'
        ]),
    },
    methods: {
        afterDispatch() {
            $('.kt-selectpicker').selectpicker({
                size: 4,
                liveSearch: true,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })
        },
    },
    mounted() {
        let params = {'query[without_pagination]' : 1}
        this.$store.dispatch('collective/fetch', params).then(this.afterDispatch)
    },
}
</script>
<style scoped>

</style>